/**
 * Mã giới thiệu sống trong cookie 30 ngày, không phải chỉ trong thanh địa chỉ.
 *
 * Người được giới thiệu hiếm khi bấm link rồi đăng ký ngay: họ đọc bài, đóng
 * tab, vài hôm sau mới quay lại bằng đường khác. Nếu chỉ đọc `?ref=` lúc mở
 * trang đăng ký thì công của đối tác bay mất ở đúng những lượt đó. Mã mới ghi
 * đè mã cũ — lần giới thiệu gần nhất là lần được tính.
 */

export const REFERRAL_COOKIE = "facego_ref";
export const REFERRAL_TTL_DAYS = 30;

/*
  Ưu đãi công bố khi **chưa** tra ra người giới thiệu.

  Khớp mặc định xuất xưởng của backend (`affiliate_referral_trial_days` và
  `affiliate_referral_discount_percent`). Số thật đi kèm mỗi lượt tra mã, nên
  hai hằng này chỉ dùng cho lúc ô còn trống — chỗ nào đã có `referrer` thì phải
  đọc số của chính người đó, vì admin đổi cấu hình được.
*/
export const REFERRAL_TRIAL_DAYS = 7;
export const REFERRAL_DISCOUNT_PERCENT = 20;

/** Cùng bộ lọc với backend: chỉ chữ và số, tối đa 20 ký tự, viết hoa. */
export function normalizeReferralCode(raw: string): string {
  return raw.replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, 20);
}

export function readReferralCookie(): string {
  const prefix = `${REFERRAL_COOKIE}=`;
  const entry = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  return entry ? normalizeReferralCode(decodeURIComponent(entry.slice(prefix.length))) : "";
}

export function writeReferralCookie(code: string): void {
  const normalized = normalizeReferralCode(code);
  if (!normalized) return;
  const maxAge = REFERRAL_TTL_DAYS * 24 * 60 * 60;
  // Trang chạy http khi dev; gắn Secure ở đó thì trình duyệt bỏ luôn cookie.
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${REFERRAL_COOKIE}=${normalized}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
}

export function clearReferralCookie(): void {
  document.cookie = `${REFERRAL_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax`;
}

/**
 * Gọi ở mọi lượt mở trang: thấy `?ref=` thì cất vào cookie và gia hạn thêm 30
 * ngày, không thấy thì dùng lại mã đã cất. Trả về mã đang có hiệu lực.
 */
export function captureReferralCode(search: string = window.location.search): string {
  const fromUrl = normalizeReferralCode(new URLSearchParams(search).get("ref") || "");
  if (fromUrl) {
    writeReferralCookie(fromUrl);
    return fromUrl;
  }
  return readReferralCookie();
}
